const INTRO_DRAFT_STORAGE_KEY = 'waitlistIntroDraft';
export const INTRO_DRAFT_TTL_MS = 3 * 24 * 60 * 60 * 1000;

type StoredDraft = { text: string; savedAt: number };

const parseDraft = (raw: string | null): StoredDraft | null => {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<StoredDraft>;
    return typeof parsed.text === 'string' && typeof parsed.savedAt === 'number'
      ? { text: parsed.text, savedAt: parsed.savedAt }
      : null;
  } catch {
    return null;
  }
};

export function readWaitlistIntroDraft(now: number = Date.now()): string {
  try {
    const draft = parseDraft(localStorage.getItem(INTRO_DRAFT_STORAGE_KEY));
    if (draft && now - draft.savedAt < INTRO_DRAFT_TTL_MS) return draft.text;
    localStorage.removeItem(INTRO_DRAFT_STORAGE_KEY);
    return '';
  } catch {
    return '';
  }
}

export function saveWaitlistIntroDraft(
  introMessage: string,
  now: number = Date.now()
): void {
  try {
    if (introMessage.trim()) {
      localStorage.setItem(
        INTRO_DRAFT_STORAGE_KEY,
        JSON.stringify({ text: introMessage, savedAt: now })
      );
    } else {
      localStorage.removeItem(INTRO_DRAFT_STORAGE_KEY);
    }
  } catch {
    return;
  }
}

export function clearWaitlistIntroDraft(): void {
  saveWaitlistIntroDraft('');
}
